import { Consultation } from '@components/Consultation'
import { Step } from '@components/Step'

import { ConsultationProvider } from '@/contexts/consultation'
import { WebsocketProvider } from '@/contexts/websocket'
import { useModule } from '@/hooks/useModule'
import { MODULE_TYPE } from '@/types/module'

export const Module = () => {
  const { currentModule } = useModule()

  if (currentModule?.type === MODULE_TYPE.DEFAULT) return <Step />

  if (currentModule?.type === MODULE_TYPE.CONSULTATION) {
    return (
      <ConsultationProvider>
        <div className="flex grow flex-col bg-gray-background bg-background-pattern bg-contain bg-repeat ">
          <WebsocketProvider>
            <Consultation />
          </WebsocketProvider>
        </div>
      </ConsultationProvider>
    )
  }

  return null
}
